import { Grid } from '@material-ui/core'
import { IOProps } from 'react-compose-io'
import { cabecalhoNotaFiscalRegras } from '../../../../types/tabelaTypes'
import { TabNotaFiscalIO } from './TabNotaFiscal.IO'
import { ModalPriorizar } from '../ModalPriorizar'
import { Botao } from './../../../../components/Botao/index'
import { AbaTabela } from './../AbaTabela'
import { ItemNotaFiscal } from '../ItemTransformacao'

export type TabNotaFiscalProps = {}

export default function TabNotaFiscalView({ _io }: IOProps<TabNotaFiscalIO, TabNotaFiscalProps>) {
  const { Container } = _io.styles

  function linhaTabela(props: { item: any; index: number }) {
    const { item, index } = props

    return <ItemNotaFiscal key={index} linhaItemNotaFiscal={item} index={index} atualizarDados={_io.buscarRegrasNotaFiscal} />
  }

  return (
    <>
      <Container>
        <Grid container direction="row" spacing={2} justifyContent="flex-end">
          <Grid item>
            <Botao onClick={_io.handlePriorizar} textoBotao="Priorizar" cor="primaria" estilo="outlined" />
          </Grid>
          <Grid item>
            <Botao onClick={_io.handleAdicionar} textoBotao="Adicionar" cor="primaria" estilo="contained" />
          </Grid>
        </Grid>
        <AbaTabela orderId={''} listItem={_io.regrasList} headCells={cabecalhoNotaFiscalRegras} LinhaTabela={linhaTabela}></AbaTabela>
      </Container>
      <ModalPriorizar
        isShow={_io.modalAberto}
        isClosed={_io.fecharModal}
        atualizarDados={_io.buscarRegrasNotaFiscal}
        campos={_io.getCampos()}
        regrasList={_io.regrasList}
        parceiroId={_io.parceiroId}
      />
    </>
  )
}
